import {
  dynamicElementsTexMarkdowntKey,
  dynamicElementsTextKey,
} from '@epicuro-next/constants/dynamic-elements';
import {
  LIST_ACCESS_PROVIDER_KEY,
  OPENED_LIST_DATA_PROVIDER_KEY,
} from '@epicuro-next/data-providers/providers-registry';
import { IDynamicItem } from '@epicuro-next/models/platform/dynamic-elements/dynamic-elements';

/* tslint:disable:no-duplicate-string */
export const listDescriptionItem: IDynamicItem = {
  contentTypeId: dynamicElementsTextKey,
  styles: {
    classes: ['text-muted', 'text-center'],
  },
  inputs: {
    text: {
      provider: OPENED_LIST_DATA_PROVIDER_KEY,
      property: 'description',
    },
  },
};

export const listDescriptionMarkdownItem: IDynamicItem = {
  contentTypeId: dynamicElementsTexMarkdowntKey,
  styles: {
    classes: ['text-muted', 'text-center'],
  },
  inputs: {
    text: {
      provider: OPENED_LIST_DATA_PROVIDER_KEY,
      property: 'description',
    },
  },
};

export const listDescriptionEditableItem: IDynamicItem = {
  contentTypeId: dynamicElementsTextKey,
  styles: {
    classes: ['text-muted'],
    variables: {
      '--text-editable-dynamic-text-align': 'center',
    },
  },
  inputs: {
    text: {
      provider: OPENED_LIST_DATA_PROVIDER_KEY,
      property: 'description',
    },
    isEditAllowed: {
      provider: LIST_ACCESS_PROVIDER_KEY,
      property: 'isListAllowedForEdit',
    },
    isMultiline: true,
    maxCharacters: 400,
    placeholder: '@@listDescriptionPlaceholder',
  },
};
